// components
import Landing from "../Components/Landing/Landing";
const LandingPage = () => {
    return (
        <Landing />
    )

}
export default LandingPage;